import Container from "@mui/material/Container";
import React from "react";
import { TEMPLATE_ID_TASK } from "../../config/templates";

const TaskTemplate = props => {

	const { children } = props;

	return (
		<React.Fragment>
			<main data-template-id={TEMPLATE_ID_TASK} id="main">
				<Container
					disableGutters={true}
					maxWidth="md"
					sx={{ marginLeft: "auto", marginRight: "auto", paddingBottom: 3, paddingTop: 3 }}
				>
					{children}
				</Container>
			</main>
		</React.Fragment>
	);
};

export default TaskTemplate;